import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { editPlotFromSociety, removePlotFromSociety, getPlotById } from "../../api";

// Thunk for editing a plot within a society
export const editPlot = createAsyncThunk(
  "plots/editPlot",
  async ({ societyId, plotId, plotData }, { rejectWithValue }) => {
    try {
      const response = await editPlotFromSociety(societyId, plotId, plotData);
      return response; // return the updated plot data
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Thunk for removing a plot from a society
export const deletePlot = createAsyncThunk(
  "plots/deletePlot",
  async ({ societyId, plotId }, { rejectWithValue }) => {
    try {
      await removePlotFromSociety(societyId, plotId);
      console.log("Plot successfully deleted:", plotId);
      return plotId;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Thunk for fetching a plot by ID (for sale_history)
export const fetchPlotById = createAsyncThunk(
  "plots/fetchPlotById",
  async (plotId, { rejectWithValue }) => {
    try {
      const response = await getPlotById(plotId);
      return response; // return the plot data (including sale_history)
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

const plotSlice = createSlice({
  name: "plots",
  initialState: {
    plots: [],
    loading: false,
    error: null,
    selectedPlot: null, // for storing fetched plot by ID
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(editPlot.pending, (state) => {
        state.loading = true;
      })
      .addCase(editPlot.fulfilled, (state, action) => {
        state.loading = false;
        const updatedPlotIndex = state.plots.findIndex(
          (plot) => plot._id === action.payload._id
        );
        if (updatedPlotIndex !== -1) {
          state.plots[updatedPlotIndex] = action.payload;
        }
      })
      .addCase(editPlot.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deletePlot.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePlot.fulfilled, (state, action) => {
        state.loading = false;
        state.plots = state.plots.filter((plot) => plot._id !== action.payload);
      })
      .addCase(deletePlot.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchPlotById.pending, (state) => {
        state.loading = true;
        state.selectedPlot = null;
      })
      .addCase(fetchPlotById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedPlot = action.payload;
      })
      .addCase(fetchPlotById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.selectedPlot = null;
      });
  },
});

export default plotSlice.reducer;
